import type { ModuleSchema } from './types.js';

/** Build the initial editable parameter object from a module's declared defaults. */
export function paramsFromSchema(module: ModuleSchema): Record<string, any> {
  const out: Record<string, any> = {};
  for (const slider of module.sliders) out[slider.key] = slider.default;
  if (module.selects) {
    for (const select of module.selects) out[select.key] = select.default;
  }
  if (module.textParams) {
    for (const textParam of module.textParams) out[textParam.key] = textParam.default;
  }
  return out;
}
